export default "__VITE_ASSET__Bo$sZae7__"